import React, { useState, useEffect } from "react";
import { loadJSON, saveJSON } from "../utils/jsonUtils";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  CardContent,
  CardActions,
  Avatar,
  IconButton,
  Typography,
  Grid,
  TextField,
  AppBar,
  Toolbar,
  CircularProgress,
} from "@mui/material";
import { Edit, Delete, Add, Visibility, ExitToApp } from "@mui/icons-material";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isAdminSessionValid } from "../utils/passwordUtils";
import ImageUploader, { compressBase64Image, uploadImageToServer } from "../components/ImageUploader";
import ServiceStructureDialog from "../components/ServiceStructureDialog";
import PageWrapper from "../components/PageWrapper";

const AdminPanel = ({ settings, setAuthenticated }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage =
    searchParams.get("page") || Object.keys(settings.pages)[0];

  const [selectedPage, setSelectedPage] = useState(initialPage);
  const [content, setContent] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingElement, setEditingElement] = useState(null);
  const [editedContent, setEditedContent] = useState("");
  const [editedId, setEditedId] = useState(""); // Added state for ID
  const [isSaving, setIsSaving] = useState(false);
  const [openServiceDialog, setOpenServiceDialog] = useState(false);
  const [selectedStructure, setSelectedStructure] = useState(null);

  
  const [uploadToServer, setUploadToServer] = useState(false);
  const [resizeIfTooBig, setResizeIfTooBig] = useState(false);
  
  const [selectedFile, setSelectedFile] = useState(null); // Le fichier brut
  const [previewUrl, setPreviewUrl] = useState(""); // Pour aperçu optionnel
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file)); // Pour affichage rapide dans un <img />
    }
  };

  useEffect(() => {
    if (!isAdminSessionValid()) {
      navigate("/admin");
    }
  }, [navigate]);

  useEffect(() => {
    setSearchParams({ page: selectedPage });
    const loadPageContent = async () => {
      const data = await loadJSON(selectedPage);
      setContent(data);
    };
    loadPageContent();
  }, [selectedPage, setSearchParams]);

  const openPreview = (element) => {
    if (element.type === "serviceStructure") {
      openServicePreview(element);
    } else {
      setPreviewContent(element);
      setPreviewOpen(true);
    }
  };

  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewContent(null);
  };

  const openEditDialog = (element) => {
  if (element.type === "serviceStructure") {
      setSelectedStructure(element);
      setOpenServiceDialog(true);
    } else {
      setEditingElement(element);
      setEditedContent(element.content);
      setEditedId(element.id);
      setEditDialogOpen(true);
    }
  };

  const openAddTextDialog = () => {
   setEditingElement({ type: "text", content: null });
    setEditedContent(""); // Clear content
    setEditedId("txt-" + Date.now().toString()); // Set ID with a default value
    setEditDialogOpen(true);
  };

  const openAddImageDialog = () => {
    setEditingElement({ type: "image", content: null });
    setEditedContent(""); // Clear content
    setEditedId("img-" + Date.now().toString()); // Set ID with a default value
    setEditDialogOpen(true);
  };

  const closeEditDialog = () => {
    setUploadToServer(false); // Reset to default
    setResizeIfTooBig(false); // Reset to default
    setSelectedFile(null); // Reset selected file
     setEditDialogOpen(false);
    setEditingElement(null);
    setPreviewUrl(""); // Reset preview URL
  };

  const proceedToSave = async (currentEditedContent) => {
    const updatedElements = content.elements.map((el) =>
      el.id === editingElement.id
        ? { ...el, content: currentEditedContent, id: editedId || el.id }
        : el
    );

    const updatedContent = {
      ...content,
      elements: updatedElements,
      timestamp: Date.now(),
    };
    setContent(updatedContent);
    await saveJSON(selectedPage, updatedContent);
    setIsSaving(false);
    closeEditDialog();
  }

  const saveEditedContent = async () => {
    console.log("saveEditedContent editingElement", editingElement);
    setIsSaving(true);

    if (editingElement.type === "image" && selectedFile) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64 = reader.result;
        const compressed = await compressBase64Image(base64, 0.8, resizeIfTooBig);
  
        let finalImageUrl = "";
        if (uploadToServer) {
          const fileName = selectedFile.name.replace(/\.[^/.]+$/, "") + ".webp";
          const storagePath = settings.storageDirFromScript;
  
          const imageUrl = await uploadImageToServer(compressed, fileName, storagePath);
          finalImageUrl = settings.websiteName + settings.scriptsDir  + imageUrl;
        } else {
          finalImageUrl = compressed;
        }
  
        setEditedContent(finalImageUrl);
        proceedToSave(finalImageUrl); // Appelle ta logique réelle de sauvegarde ici
      };
  
      reader.readAsDataURL(selectedFile);
    } else {
      proceedToSave(editedContent);
    }
    
  };
  

  /*

   let finalImageUrl = editedContent;

  if (editingElement.type === "image" && selectedFile) {
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result;
      const compressed = await compressBase64Image(base64, 0.8, resizeIfTooBig);

      if (uploadToServer) {
        const fileName = selectedFile.name.replace(/\.[^/.]+$/, "") + ".webp";
        const storagePath = settings.storageDirFromScript;

        const imageUrl = await uploadImageToServer(compressed, fileName, storagePath);
        finalImageUrl = settings.websiteName + settings.scriptsDir + imageUrl;
      } else {
        finalImageUrl = compressed;
      }

      setEditedContent(finalImageUrl);
      proceedToSave(); // Appelle ta logique réelle de sauvegarde ici
    };

    reader.readAsDataURL(selectedFile);
  } else {
  const fileSelectedChanged = () => {
    if (fileSelected) {
      const fileReader = new FileReader();
      fileReader.onload = async () => {
        const compressedImage = await compressBase64Image(
          fileReader.result,
          0.8,
          resizeIfTooBig
        );
        console.log("resizeIfTooBig :", resizeIfTooBig);
        console.log("uploadToServer :", uploadToServer);

        if (uploadToServer) {
          const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
          const storagePath = settings.storageDirFromScript;
          const imageUrl = await uploadImageToServer(
            compressedImage,
            fileName,
            storagePath
          );
          setEditedContent(settings.websiteName + settings.scriptsDir + imageUrl);
          console.log("Image uploaded to server:", imageUrl);
        } else {
          setEditedContent(compressedImage);
          console.log("Image not uploaded to server, using local base64.");
        }
      };
      fileReader.readAsDataURL(file);
    }
  };*/

  const addNewElement = async () => {

    console.log("saveEditedContent editingElement", editingElement);
    setIsSaving(true);

    if (editingElement.type === "image" && selectedFile) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64 = reader.result;
        const compressed = await compressBase64Image(base64, 0.8, resizeIfTooBig);
  
        let finalImageUrl = "";
        if (uploadToServer) {
          const fileName = selectedFile.name.replace(/\.[^/.]+$/, "") + ".webp";
          const storagePath = settings.storageDirFromScript;
  
          const imageUrl = await uploadImageToServer(compressed, fileName, storagePath);
          finalImageUrl = settings.websiteName + settings.scriptsDir + imageUrl;
        } else {
          finalImageUrl = compressed;
        }
  
        setEditedContent(finalImageUrl);
        proceedToAddSave(finalImageUrl); // Appelle ta logique réelle de sauvegarde ici
      };
  
      reader.readAsDataURL(selectedFile);
    } else {
      proceedToAddSave(editedContent);
    }
  }

  const proceedToAddSave = async (currentContent) => {
    console.log("addNewElement editingElement", editingElement);
    const newElement = {
      id:
        editedId ||
        (editingElement.type === "text" ? "txt-" : "img-") +
          Date.now().toString(), // Generate unique ID if none is provided
      type: editingElement.type,
      content: currentContent,
    };

    let updatedElements = [];
    let updatedContent = {};
    if (content) {
      updatedElements = [...content.elements, newElement];
      updatedContent = { ...content, elements: updatedElements };
    } else {
      updatedElements = [newElement];
      updatedContent = { elements: updatedElements };
    }
    console.log("PREVIOUS content", content);
    console.log("newElement", newElement);
    console.log("UPDATED content", updatedContent);

    setContent(updatedContent);
    await saveJSON(selectedPage, updatedContent);
    setIsSaving(false);
    closeEditDialog();
  };

  const handleLogout = () => {
    setAuthenticated(false);
    localStorage.setItem("admin_authenticated", "false");
    localStorage.setItem("adminSession", "false");
    navigate("/");
  };

  const deleteElement = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cet élément ?")) {
      const updatedElements = content.elements.filter((el) => el.id !== id);
      const updatedContent = {
        ...content,
        elements: updatedElements,
        timestamp: Date.now(),
      };

      await saveJSON(selectedPage, updatedContent);
      setContent(updatedContent);
    }
  };

  const handleSaveStructure = (newStructure) => {
    const updatedContent = {
      ...content,
      elements: [...content.elements, newStructure],
    };
    saveJSON(selectedPage, updatedContent);
    setContent(updatedContent);
  };

  const handleEditStructure = (updatedStructure) => {
    const updatedElements = content.elements.map((el) =>
      el.id === updatedStructure.id ? updatedStructure : el
    );

    const updatedContent = {
      ...content,
      elements: updatedElements,
    };

    saveJSON(selectedPage, updatedContent);
    setContent(updatedContent);
    setOpenServiceDialog(false);
  };

  const openServicePreview = (serviceStructure) => {
    setPreviewContent(serviceStructure);
    setPreviewOpen(true);
  };

  return (
    <PageWrapper style={{ backgroundColor: "#000", marginBottom: "2rem !important" }}>
      <ServiceStructureDialog
        open={openServiceDialog}
        onClose={() => setOpenServiceDialog(false)}
        onSave={selectedStructure ? handleEditStructure : handleSaveStructure}
        initialData={selectedStructure}
      />
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Panneau d'Administration
          </Typography>
          <Button
            color="inherit"
            onClick={handleLogout}
            startIcon={<ExitToApp />}>
            Déconnexion
          </Button>
        </Toolbar>
      </AppBar>

      <select
        onChange={(e) => setSelectedPage(e.target.value)}
        value={selectedPage}
        style={{
          padding: "8px",
          marginBottom: "20px",
          width: "100%",
          fontSize: "16px",
        }}>
        {Object.keys(settings?.pages).map((pageKey) => (
          <option key={pageKey} value={pageKey}>
            {settings.pages[pageKey].title}
          </option>
        ))}
      </select>

      <div style={{ display: "flex", gap: "1rem" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={openAddTextDialog}>
          Ajouter un texte
        </Button>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Add />}
          onClick={openAddImageDialog}>
          Ajouter une image
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={() => setOpenServiceDialog(true)}>
          Ajouter une structure
        </Button>
      </div>

      {content && (
        <div>
          <Typography variant="h6" style={{ marginBottom: "15px" }}>
            Éléments de la page
          </Typography>
          <Grid container spacing={2}>
            {content.elements.map((element) => (
              <Grid item xs={12} sm={6} md={4} key={element.id}>
                <Card
                  variant="outlined"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: 1,
                    borderRadius: 1,
                    overflow: "hidden",
                  }}>
                  <CardContent
                    sx={{
                      flexGrow: 1,
                      padding: "12px",
                      overflow: "auto",
                    }}>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      noWrap
                      sx={{ marginBottom: "6px" }}>
                      {element.id}
                    </Typography>

                    {element.type === "image" ? (
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          paddingTop: "100%", // ratio 1:1
                          marginBottom: "8px",
                        }}>
                        <Avatar
                          src={element.content}
                          variant="rounded"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    ) : element.type === "serviceStructure" ? (
                      <div style={{ maxHeight: "180px", overflow: "auto" }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}>
                          {element.title}
                        </Typography>
                        {element.categories?.map((category, i) => (
                          <div key={i} style={{ marginTop: "6px" }}>
                            <Typography variant="caption" color="primary">
                              {category.name}
                            </Typography>
                            {category.services?.map((service, j) => (
                              <div
                                key={j}
                                style={{
                                  fontSize: "0.75rem",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}>
                                <span>{service.name}</span>
                                <span style={{ fontWeight: "bold" }}>
                                  {service.price === "sur devis"
                                    ? "Sur devis"
                                    : service.price}
                                </span>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ maxHeight: "100px", overflow: "hidden" }}>
                        <ReactQuill
                          value={element.content}
                          readOnly={true}
                          theme="bubble"
                          style={{ fontSize: "0.85rem" }}
                        />
                      </div>
                    )}
                  </CardContent>

                  <CardActions
                    sx={{
                      justifyContent: "flex-end",
                      padding: "4px 8px",
                    }}>
                    <IconButton
                      size="small"
                      onClick={() => openPreview(element)}>
                      <Visibility fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => openEditDialog(element)}>
                      <Edit fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => deleteElement(element.id)}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </div>
      )}

      {/* Aperçu */}
      <Dialog open={previewOpen} onClose={closePreview} maxWidth="sm" fullWidth>
        <DialogTitle>Aperçu</DialogTitle>
        <DialogContent>
          {previewContent && previewContent.type === "image" ? (
            <img
              src={previewContent.content}
              alt="Aperçu"
              style={{
                width: "100%",
                maxHeight: "500px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          ) : previewContent && previewContent.type === "serviceStructure" ? (
            <div>
              <Typography variant="h6" gutterBottom>
                {previewContent.title}
              </Typography>
              <Typography variant="body2" color="textSecondary" paragraph>
                {previewContent.description}
              </Typography>

              {previewContent.categories?.map((category, catIndex) => (
                <div key={catIndex} style={{ marginBottom: "12px" }}>
                  {/* Category Name and Description */}
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    sx={{
                      fontWeight: "bold",
                      borderBottom: "2px solid #1976d2",
                      paddingBottom: "4px",
                      marginBottom: "8px",
                    }}>
                    {category.name}
                  </Typography>
                  {category.description && (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ marginBottom: "12px" }}>
                      {category.description}
                    </Typography>
                  )}

                  {/* Services in the Category */}
                  {category.services?.map((service, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "#fff",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        marginTop: "6px",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}>
                      {/* Service Name and Description */}
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold" }}>
                        {service.name}
                      </Typography>
                      {service.description && (
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ fontSize: "0.875rem" }}>
                          {service.description}
                        </Typography>
                      )}

                      {/* Service Duration and Price */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold", fontSize: "0.875rem" }}>
                          Durée : {service.duration}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            color:
                              service.price === "sur devis"
                                ? "#ff9800"
                                : "#1976d2",
                          }}>
                          {service.price === "sur devis"
                            ? "Sur devis"
                            : `${service.price}`}
                        </Typography>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <ReactQuill
              value={previewContent?.content || ""}
              readOnly={true}
              theme="bubble"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closePreview} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Édition */}
      <Dialog
        open={editDialogOpen}
        onClose={closeEditDialog}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>Édition de l'élément</DialogTitle>
        <DialogContent>
          <TextField
            label="ID de l'élément"
            fullWidth
            value={editedId}
            onChange={(e) => setEditedId(e.target.value)} // Allow editing ID
            sx={{ marginBottom: "16px" }}
          />
          {editingElement && editingElement.type === "image" ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              {previewUrl === "" && editingElement.content && <img src={editingElement.content} alt="Preview" style={{ maxWidth: "100%" }} />}
              {previewUrl !== "" && <img src={previewUrl} alt="Preview" style={{ maxWidth: "100%" }} />}
              <input type="file" accept="image/*" onChange={handleFileChange} />
              <label>
                <input
                  type="checkbox"
                  checked={uploadToServer}
                  onChange={(e) => setUploadToServer(e.target.checked)}
                />
                Fichier externe ?
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={resizeIfTooBig}
                  onChange={(e) => setResizeIfTooBig(e.target.checked)}
                />
                Réduire la taille ?
              </label>
            </div>
          ) : (
            <ReactQuill
              value={editedContent}
              onChange={setEditedContent}
              theme="snow"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditDialog} color="secondary">
            Annuler
          </Button>
          <Button
            onClick={
              editingElement && editingElement.content !== null
                ? saveEditedContent
                : addNewElement
            }
            color="primary"
            disabled={isSaving}>
            {isSaving ? <CircularProgress size={24} /> : "Enregistrer"}
          </Button>
        </DialogActions>
      </Dialog>
    </PageWrapper>
  );
};

export default AdminPanel;
